var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"Sélectionner un statut","value":_vm.value,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default"),_vm._l((_vm.statuses),function(status){return _c('el-option',{key:status,attrs:{"value":status,"label":_vm.$t(`schoolLists.statuses.${status}`)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }